import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import CouvertureMetallique from "@/components/CouvertureMetallique";
import Realisations from "@/components/Realisations";
import Avis from "@/components/Avis";
import Zone from "@/components/Zone";
import Contact from "@/components/Contact";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Footer from "@/components/Footer";
import MentionsLegales from "@/components/MentionsLegales";

function HomePage() {
  return (
    <div className="App bg-[#09090B] text-white font-body" data-testid="app-root">
      <div className="grain-overlay" />
      <Header />
      <main>
        <Hero />
        <Realisations />
        <Avis />
        <Marquee />
        <Services />
        <CouvertureMetallique />
        <Zone />
        <Contact />
      </main>
      <Footer />
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}


function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true, anchors: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/mentions-legales" element={<MentionsLegales />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
